import { AgreementsState } from 'reducers/agreements/AgreementsState';
import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getAgreementsState = createSelector(
    (state: RootState) => state.agreements,
    (agreements: AgreementsState) => agreements
);

export const getActiveAgreements = createSelector(
    getAgreementsState,
    (agreements: AgreementsState) => agreements.agreements.filter(agreement => agreement.active)
);

export const getAgreementLoading = createSelector(
    getAgreementsState,
    (agreements: AgreementsState) => agreements.loading
);
